export default __webpack_public_path__ + "static/media/logo_iteprevengo.62759f7d.png";